var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73768 5.39821C4.64398 5.39821 5.37868 4.66351 5.37868 3.75721C5.37868 2.85091 4.64398 2.11621 3.73768 2.11621C2.83138 2.11621 2.09668 2.85091 2.09668 3.75721C2.09668 4.66351 2.83138 5.39821 3.73768 5.39821Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92779 6.64102V15.7453H9.75454V11.243C9.75454 10.055 9.97804 8.90452 11.451 8.90452C12.9038 8.90452 12.9218 10.2628 12.9218 11.318V15.746H15.75V10.7533C15.75 8.30077 15.222 6.41602 12.3555 6.41602C10.9793 6.41602 10.0568 7.17127 9.67954 7.88602H9.64129V6.64102H6.92779ZM2.32129 6.64102H5.15254V15.7453H2.32129V6.64102Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a00536f58dee6203006b9c1b6cfe668d.svg";
export { ForwardRef as ReactComponent };